import React, { useEffect } from "react";
import Distributorveryfection from "../../components/employees/Distributorveryfection";

const DistributorveryfectionPage = () => {

    useEffect(() => {
        document.body.id = "Distributorveryfection-004";
      }, []);

  return (
    <div className='commom-001'>
     <Distributorveryfection />
    </div>
  );
};

export default DistributorveryfectionPage;
